import React, {useEffect, useMemo, useState} from 'react';
import {Tab} from 'semantic-ui-react';
import {useBlockUI} from "../../../../shared/services/block-ui-service";
import SessionStorage from "../../../../store/session";
import {SessionUser} from "../../../../models/session-user";
import {useLocation} from "react-router-dom";
import ClientDriversListComponent from "../../../../components/client-drivers-list/drivers-list";


const ClientDriversList = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [clientId, setClientId] = useState<string | null>(null); // Estado para armazenar o clientId
    const [sessionUser, setSessionUser] = useState<SessionUser>();
    const [activeIndex, setActiveIndex] = useState<number>();
    const location = useLocation();


    const blockUI = useBlockUI();
    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    useEffect(() => {
        async function updateSessionUser() {
            const user = await SessionStorage.getSession();
            setSessionUser(user)
        }

        updateSessionUser()
    }, [])

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const id = params.get('clientId');
        setClientId(id);
    }, [location.search]);


    const panes = useMemo(() => [
        {
            menuItem: 'Listagem de Motoristas do Cliente',
            render: () => <Tab.Pane>
                {clientId && <ClientDriversListComponent clientId={clientId}/>}
            </Tab.Pane>
        },
    ], [clientId]);

    return (
        <Tab
            menu={{fluid: true, vertical: false, tabular: true}}
            panes={panes}
            activeIndex={activeIndex}
            onTabChange={(e, {activeIndex}) => {
                setActiveIndex(typeof activeIndex === 'string' ? parseInt(activeIndex, 10) : activeIndex);
            }}
        />
    );
};

export default ClientDriversList;
